import { ThemeProvider } from "styled-components";
import { useState } from "react";
import { darkTheme, lightTheme } from './utils/Themes.js';
import Navbar from "./components/Navbar";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Store from './pages/Store';
import ScrollButton from "./components/scrollbutton/scrolltotop.js";

// Redirect component
const RedirectToResume = () => {
  window.location.href = "https://drive.google.com/file/d/16IjRIJRwRMT7WvaZBJcKZoHfptj62XyH/view?usp=sharing";
  return null;
};

// Redirect component
const RedirectToDocument = () => {
  window.location.href = "https://drive.google.com/drive/folders/10v2rgyN883DIerbKhFi37trU-19s6K5n?usp=drive_link";
  return null;
};

function App() {
  const [darkMode, setDarkMode] = useState(true);
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        {/* Navbar remains visible across all pages */}
        <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
        
        <Routes>
          {/* Home Page Route */}
          <Route
            path="/"
            element={<Home openModal={openModal} setOpenModal={setOpenModal} />}
          />
          
          {/* Store Page Route */}
          <Route
            path="/products"
            element={<Store openModal={openModal} setOpenModal={setOpenModal} />}
          />

          {/* Resume Redirect Route */}
          <Route path="/resume" element={<RedirectToResume />} />
          <Route path="/documents" element={<RedirectToDocument />} />
        </Routes>
        
        {/* Scroll-to-top button */}
        <ScrollButton />
      </Router>
    </ThemeProvider>
  );
}

export default App;
